import React from 'react';
import * as Scrivito from 'scrivito';

Scrivito.provideWidgetClass('AboutUsContainerWidget', {
  attributes: {
    widgetlist_1: 'widgetlist',
    widgetlist_2: 'widgetlist',
    widgetlist_3: 'widgetlist',
    widgetlist_4: 'widgetlist',
  },
});

// The classes are the Rails partial's (bar its `col-xs-12`, which has no effect
// in this stack) and now mean what they meant there: four across from 992px, two
// from 768px, stacked below – see the breakpoint map in styles/main.scss.
// `col-lg-3 col-md-6` moved both steps up to 1200 and 992, and the extra `g-4`
// widened the 30px gutter the row already has.
const AboutUsContainerWidget = Scrivito.connect(({ widget }) => (
  <div className="row">
    {[1, 2, 3, 4].map((n) => (
      <div key={n} className="col-md-3 col-sm-6">
        <Scrivito.ContentTag tag="div" attribute={`widgetlist_${n}`} content={widget} />
      </div>
    ))}
  </div>
));

Scrivito.provideComponent('AboutUsContainerWidget', AboutUsContainerWidget);

Scrivito.provideEditingConfig('AboutUsContainerWidget', {
  title: 'Team Grid (4 columns)',
  properties: ['widgetlist_1', 'widgetlist_2', 'widgetlist_3', 'widgetlist_4'],
  attributes: {
    widgetlist_1: { title: 'Column 1' },
    widgetlist_2: { title: 'Column 2' },
    widgetlist_3: { title: 'Column 3' },
    widgetlist_4: { title: 'Column 4' },
  },
});

export default AboutUsContainerWidget;
